export default {
	"ProductInfo.GrowBeans": "成長豆",
	"ProductInfo.SubscriptionUpgrade": "訂閱升級"
}